'use client';

import { Close } from '../../icons';
import { styled } from '../../styles';

export const AlertCloseIcon = styled(Close)(({ theme }) => ({
  color: theme.palette.text3,
}));
